import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';

/*
    Source : https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fcommon%2Fcontrols%2Fpackages%2Fcontrols%2Fowa-bit-flags%2Flib%2Futils%2FlistViewBitFlagsUtil.ts&_a=contents&version=GBmaster
    PLEASE DO NOT CHANGE THE BIT POSITIONS FOR THE FLAGS STORED IN ListViewBitFlagsMasks
*/
export const enum ListViewBitFlagsMasks {
    HideSenderImage = 1 << 3, // Flag to indicate if listview sender images are shown or not. 0 => Show, 1 => Hide.
    ExcludeDeletedItemsInSearch = 1 << 8, // Flag to indicate whether deleted items should be included in search results
}

/**
 * Gets a boolean to indicate if the n th bit is 1
 * @param bitMask represents the nth bit
 * @return true if nth bit is 1, false if 0
 */
export function getIsBitSet(bitMask: ListViewBitFlagsMasks): boolean {
    const listViewBitFlags = getUserConfiguration().ViewStateConfiguration.ListViewBitFlags;
    return !!(bitMask & listViewBitFlags);
}

/**
 * Set bit flag
 * @param value set to 1 if true, 0 otherwise
 * @param bitMask represents the nth bit
 */
export const setBit = action('setBit')(function setBit(
    value: boolean,
    bitMask: ListViewBitFlagsMasks
) {
    // Already same value, no need to set again and update user config
    if (getIsBitSet(bitMask) === value) {
        return;
    }
    updateUserConfiguration(userConfig => {
        if (value) {
            // Set the bit to 1
            userConfig.ViewStateConfiguration.ListViewBitFlags |= bitMask;
        } else {
            // Clear the bit to 0
            userConfig.ViewStateConfiguration.ListViewBitFlags &= ~bitMask;
        }
    });
});
